import { RoutingHelper } from 'config/RoutingHelper'
import { AuthUtils } from 'main/common/utils/AuthUtils'
import { AuthRoutes } from 'main/modules/auth/AuthRoutes'
import { UserMainLayoutCP } from 'main/modules/user/components/user-main-layout/UserMainLayoutCP'
import React from 'react'

/**
 * Determina direcionamento apropriado para definacao de rotas / telas
 * de acordo o tipo de pessoa logada atualmente (se houver alguma).
 */
export function PrivateAccessVerifierCP(): JSX.Element {
    return AuthUtils.isUserLogged() ? <UserMainLayoutCP/> : RoutingHelper.renderRedirect(AuthRoutes.USER_LOGIN)
}
